/*
  BFCM 2026 tag-based sale display
  ---------------------------------
  Shows a slashed regular price next to the discounted price for products
  tagged 2026BFCM10 / 2026BFCM20 / 2026BFCM25 / 2026BFCM50.

  The real discount is a native Shopify automatic discount. This script only
  changes what shoppers SEE before checkout; it never changes product prices.

  Liquid outputs a hidden marker <span data-tc-sale-pct="20"> for each sale
  product (snippets/price-ui-badges.liquid, snippets/product-full.liquid).
  A MutationObserver re-applies the sale price whenever the theme rewrites a
  price: variant changes, quick shop, one-time/subscription toggle, load more.

  Collection grid prices are already rendered on the server by
  snippets/product-info.liquid; this script recognises them and leaves them.
*/
(function () {
  if (window.tcBfcmSale) return;
  window.tcBfcmSale = true;

  // Set to true only if the automatic discount also applies to subscriptions.
  var APPLY_TO_SUBSCRIPTIONS = false;

  var style = document.createElement('style');
  style.textContent =
    '.tc-was:not(.was_price){text-decoration:line-through;opacity:.7;margin-left:.4em;}' +
    '.tc-rebuy-hide{display:none!important;}' +
    '.tc-rebuy-sale{color:rgb(219,4,37);}' +
    '.tc-rebuy-was{color:rgb(43,42,42);margin-left:.3em;}';
  document.head.appendChild(style);

  // ---- money helpers: reuse the exact format the theme rendered ----------
  function parseMoney(text) {
    if (!text) return null;
    var m = text.match(/\d[\d.,']*\d|\d/);
    if (!m) return null;
    var num = m[0];
    var decSep = /[.,]\d{2}$/.test(num) ? num.charAt(num.length - 3) : null;
    var intPart = decSep ? num.slice(0, -3) : num;
    var th = intPart.match(/[^\d]/);
    var digits = num.replace(/[^\d]/g, '');
    if (!digits) return null;
    var cents = decSep ? parseInt(digits, 10) : parseInt(digits, 10) * 100;
    if (!(cents > 0)) return null;
    return { cents: cents, raw: num, text: text, decSep: decSep, thSep: th ? th[0] : '' };
  }

  function group(n, sep) {
    var s = String(n);
    return sep ? s.replace(/\B(?=(\d{3})+(?!\d))/g, sep) : s;
  }

  function formatLike(p, cents) {
    var out;
    if (p.decSep) {
      var dec = String(cents % 100);
      if (dec.length < 2) dec = '0' + dec;
      out = group(Math.floor(cents / 100), p.thSep) + p.decSep + dec;
    } else {
      out = group(Math.round(cents / 100), p.thSep);
    }
    return p.text.replace(p.raw, out);
  }

  function salePrice(cents, pct) {
    return Math.round((cents * (100 - pct)) / 100);
  }

  // ---- one price group: current price + slashed price ---------------------
  function processGroup(priceEl, getCompare, saleClassEl, saleClass, pct, subsMode) {
    if (!priceEl) return;
    // Outermost .money elements only (the shop money format wraps prices in a
    // second span.money), and never the slashed price, which this theme can
    // nest inside the current-price element.
    var leaves = Array.prototype.slice.call(priceEl.querySelectorAll('.money')).filter(function (l) {
      var p = l.parentElement;
      while (p && p !== priceEl) {
        if (p.classList.contains('money') || p.classList.contains('was_price') ||
            p.hasAttribute('data-compare-at-price')) return false;
        p = p.parentElement;
      }
      return !l.classList.contains('was_price');
    });
    if (!leaves.length) return;

    var subsOnly = leaves.some(function (l) {
      return l.classList.contains('onlySubscription');
    });

    if (subsMode || subsOnly) {
      // Subscription selected: show the theme's own price, no BFCM strike.
      leaves.forEach(function (l) {
        if (l.dataset.tcShown && l.textContent.trim() === l.dataset.tcShown && l.dataset.tcOrigText) {
          l.textContent = l.dataset.tcOrigText;
        }
        delete l.dataset.tcShown;
      });
      var c0 = getCompare(false);
      if (c0 && c0.dataset.tcShown && c0.textContent.trim() === c0.dataset.tcShown) {
        c0.textContent = '';
        delete c0.dataset.tcShown;
        c0.classList.remove('tc-was');
      }
      if (saleClassEl && saleClassEl.dataset.tcSaleClass) {
        saleClassEl.classList.remove(saleClass);
        delete saleClassEl.dataset.tcSaleClass;
      }
      return;
    }

    var origTexts = [];
    leaves.forEach(function (l) {
      var t = l.textContent.trim();
      if (l.dataset.tcShown && t === l.dataset.tcShown) {
        origTexts.push(l.dataset.tcOrigText || '');
        return;
      }
      var p = parseMoney(t);
      if (!p) return;
      var next = formatLike(p, salePrice(p.cents, pct));
      l.dataset.tcOrigText = t;
      l.dataset.tcShown = next;
      l.textContent = next;
      origTexts.push(t);
    });
    if (!origTexts.length) return;

    var cmp = getCompare(true);
    if (cmp) {
      var ct = cmp.textContent.trim();
      var owned = cmp.dataset.tcShown && ct === cmp.dataset.tcShown;
      // Fill the slashed price only when it is empty or ours. A real
      // compare-at price (an existing markdown) is left alone.
      if (!ct || owned) {
        var wanted = origTexts.filter(Boolean).join(' – ');
        if (ct !== wanted) {
          if (cmp.classList.contains('was_price')) {
            // The theme strikes through .was_price .money
            cmp.innerHTML = '';
            var m = document.createElement('span');
            m.className = 'money';
            m.textContent = wanted;
            cmp.appendChild(m);
          } else {
            cmp.textContent = wanted;
          }
        }
        cmp.dataset.tcShown = wanted;
        if (!cmp.classList.contains('tc-was')) cmp.classList.add('tc-was');
        if (cmp.style.display === 'none') cmp.style.display = '';
      }
    }

    if (saleClassEl && !saleClassEl.classList.contains(saleClass)) {
      saleClassEl.classList.add(saleClass);
      saleClassEl.dataset.tcSaleClass = '1';
    }
  }

  function processContainer(container, pct) {
    var subsMode =
      !APPLY_TO_SUBSCRIPTIONS && !!container.querySelector('[data-subscription-input]:checked');

    // Product page, quick shop, inline quick shop (Pixel Union price UI)
    container.querySelectorAll('.price-ui').forEach(function (ui) {
      var priceEl = ui.querySelector('.price');
      processGroup(
        priceEl,
        function (create) {
          var c = ui.querySelector('[data-compare-at-price]');
          if (!c && create && priceEl) {
            c = document.createElement('span');
            c.className = 'compare-at-price';
            c.setAttribute('data-compare-at-price', '');
            priceEl.parentNode.insertBefore(c, priceEl.nextSibling);
          }
          return c;
        },
        priceEl,
        'price--sale',
        pct,
        subsMode
      );
    });

    // Classic markup: collection grid, featured product
    container.querySelectorAll('.current_price').forEach(function (cp) {
      var wrap = cp.closest('.price, .modal_price') || cp.parentNode;
      processGroup(
        cp,
        function (create) {
          var w = wrap.querySelector('.was_price');
          if (!w && create) {
            w = document.createElement('span');
            w.className = 'was_price';
            cp.parentNode.insertBefore(w, cp.nextSibling);
          }
          return w;
        },
        wrap.classList.contains('price') ? wrap : cp.parentNode,
        'sale',
        pct,
        subsMode
      );
    });
  }

  // ---- cart page: slash the regular unit price on discounted lines --------
  function processCart() {
    document.querySelectorAll('.cart__item').forEach(function (item) {
      if (!item.querySelector('.cart__item--discount')) return;
      var was = item.querySelector('.modal_price .was_price');
      var lineWas = item.querySelector('.price_total .was_price');
      var qtyInput = item.querySelector('input.quantity');
      if (!was || !lineWas || !qtyInput) return;
      var cur = was.textContent.trim();
      if (parseMoney(cur) && !(was.dataset.tcShown && cur === was.dataset.tcShown)) return; // real compare-at
      var lp = parseMoney(lineWas.textContent.trim());
      var qty = parseInt(qtyInput.value, 10);
      if (!lp || !(qty > 0)) return;
      var text = formatLike(lp, Math.round(lp.cents / qty));
      if (cur !== text) was.textContent = text;
      was.dataset.tcShown = text;
    });
  }

  // ---- Rebuy widgets (product page recommendations, cart upsells) ---------
  // Rebuy renders its own blocks and adds each product tag as a class, e.g.
  // "tag-2026bfcm20". Rebuy's price element is left untouched (Rebuy's own
  // script manages it); it is hidden and a sale price is shown beside it.
  var REBUY_TAGS = [['tag-2026bfcm50', 50], ['tag-2026bfcm25', 25], ['tag-2026bfcm20', 20], ['tag-2026bfcm10', 10]];

  function rebuyPct(block) {
    for (var i = 0; i < REBUY_TAGS.length; i++) {
      if (block.classList.contains(REBUY_TAGS[i][0])) return REBUY_TAGS[i][1];
    }
    return 0;
  }

  function processRebuy() {
    document.querySelectorAll('.rebuy-product-block').forEach(function (block) {
      var pct = rebuyPct(block);
      if (!pct) return;
      var priceBox = block.querySelector('.rebuy-product-price');
      if (!priceBox) return;
      var monies = Array.prototype.slice.call(priceBox.querySelectorAll('.rebuy-money'));
      var hasCompare = monies.some(function (m) { return /compare/.test(m.className); });
      monies.forEach(function (money) {
        if (/compare/.test(money.className)) return;
        var spans = Array.prototype.filter.call(money.children, function (s) {
          return s.tagName === 'SPAN' && !s.classList.contains('sr-only') && !s.classList.contains('tc-rebuy');
        });
        var src = spans[spans.length - 1];
        if (!src) return;
        var t = src.textContent.trim();
        var out = money.querySelector('.tc-rebuy');
        if (src.dataset.tcFor === t && out) return;
        var p = parseMoney(t);
        if (!p) return;
        if (!out) {
          out = document.createElement('span');
          out.className = 'tc-rebuy';
          src.parentNode.insertBefore(out, src.nextSibling);
        }
        out.textContent = '';
        var sale = document.createElement('span');
        sale.className = 'tc-rebuy-sale';
        sale.textContent = formatLike(p, salePrice(p.cents, pct));
        out.appendChild(sale);
        if (!hasCompare) {
          var was = document.createElement('s');
          was.className = 'tc-rebuy-was';
          was.textContent = t;
          out.appendChild(was);
        }
        src.dataset.tcFor = t;
        if (!src.classList.contains('tc-rebuy-hide')) src.classList.add('tc-rebuy-hide');
      });
    });
  }

  // ---- run -----------------------------------------------------------------
  function run() {
    document.querySelectorAll('[data-tc-sale-pct]').forEach(function (marker) {
      var pct = parseInt(marker.getAttribute('data-tc-sale-pct'), 10);
      if (!(pct > 0 && pct < 100)) return;
      var container = marker.closest('.thumbnail, .product__details, .product-details, .product_section');
      if (container) processContainer(container, pct);
    });
    processCart();
    processRebuy();
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    (window.requestAnimationFrame || setTimeout)(function () {
      scheduled = false;
      try { run(); } catch (e) { if (window.console) console.warn('tc-bfcm-sale', e); }
    });
  }

  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true
  });
  document.addEventListener('change', schedule, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  schedule();
})();
